import { Link } from "react-router-dom";

export default function ContactCTA() {
  return (
    <section className="relative py-28 px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/contact-cta-001-1600x700.jpg"
          alt="Harambee Global Ventures Nairobi connection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1F14]/88 via-[#0D1F14]/82 to-[#0D1F14]/90" />
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
            backgroundSize: "20px 20px",
          }}
        />
      </div>

      <div className="relative z-10 max-w-[900px] mx-auto text-center">
        <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-6">
          <span className="w-8 h-px bg-[#C9A961]" />
          Begin the Conversation
          <span className="w-8 h-px bg-[#C9A961]" />
        </span>

        <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
          Your Next Step Starts with a Conversation
        </h2>

        <p className="text-white/70 text-lg leading-relaxed max-w-2xl mx-auto mb-12">
          Whether you are seeking financial education, advisory guidance, a strategic partnership, or simply want to learn more about Harambee Global Ventures — we invite you to reach out. Every meaningful relationship begins with a single conversation.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <a
            href="#contact-form"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-md bg-[#C9A961] text-[#1A2B1F] font-semibold text-sm hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
          >
            Send Us a Message <i className="ri-arrow-right-line" />
          </a>
          <Link
            to="/advisory"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-md border border-white/40 text-white font-medium text-sm hover:border-[#C9A961] hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a Consultation
          </Link>
          <Link
            to="/partnerships"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-md border border-white/20 text-white/70 font-medium text-sm hover:border-[#C9A961]/50 hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore Partnerships
          </Link>
        </div>

        <div className="flex flex-wrap justify-center gap-10">
          {[
            { icon: "ri-map-pin-2-line", label: "Nairobi, Kenya" },
            { icon: "ri-global-line", label: "Global Reach" },
            { icon: "ri-time-line", label: "2–3 Day Response" },
            { icon: "ri-shield-check-line", label: "Trusted & Confidential" },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-[#C9A961] text-base`} />
              </div>
              <span className="text-white/55 text-xs uppercase tracking-wider">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
